'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var sellerProductsComponent = exports.sellerProductsComponent = {
    template: require('./products.html'),
    bindings: {
        seller: '<',
        parentState: '<',
        totalPriceDiscounts: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "$state", "productOverviewService", "Enums", "common", "sellerService", "gettextCatalog", "Analytics", "$stateParams", function controller($scope, $state, productOverviewService, Enums, common, sellerService, gettextCatalog, Analytics, $stateParams) {
        'ngInject';

        var vm = this;
        vm.productOverviewModel = null;
        vm.$onInit = init;
        vm.onFilterChange = onFilterChange;

        function init() {

            if (!vm.seller) {
                $state.go('error');
            }

            common.navigationMenu.setSellersActive();
            common.setTitle(vm.seller.name + ' ' + gettextCatalog.getString('products'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/' + vm.seller.id + '/products', vm.seller.name + ' ' + gettextCatalog.getString('products'));

            loadProducts();
        }

        function loadProducts() {
            //load the products after init
            if ($stateParams.noReloadFilter) {
                vm.productOverviewModel = productOverviewService.getProductOverviewModel();
            } else {
                vm.productOverviewModel = productOverviewService.init(Enums.searchContext.category.id);
            }

            productOverviewService.getSellerProducts($stateParams.noReloadFilter ? false : true, vm.productOverviewModel, vm.seller.id, $state.params.categoryId).then(function (model) {
                vm.productOverviewModel = model;
                listenForLocationChangeSuccess();
                model.filter.flatListsOfCategories.find(function (cl) {
                    var category = cl.list.find(function (c) {
                        return c.id === $state.params.categoryId;
                    });
                    if (category) {
                        return $state.current.ncyBreadcrumbLabel = category.name;
                    }
                    return null;
                });
            });
        }

        function listenForLocationChangeSuccess() {
            $scope.$on('$locationChangeSuccess', function () {
                productOverviewService.getSellerProducts(false, vm.productOverviewModel, vm.seller.id, $state.params.categoryId).then(function (model) {
                    vm.productOverviewModel = model;
                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                }).catch(function () {
                    $state.go('error', {}, {
                        location: false
                    });
                });
            });
        }

        function onFilterChange() {
            productOverviewService.setProductOverviewModel(vm.productOverviewModel);
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/seller/products.js
// module id = 1026
// module chunks = 0